export default function FolderIcon() {
  return (
    <svg viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M29.374 8.19H16.807l-4.095-4.11S12.597 4 12.52 4H3.626C3 4 2.5 4.522 2.5 5.178v21.657C2.5 27.479 3 28 3.626 28h25.748c.614 0 1.113-.522 1.126-1.165V9.355c0-.643-.5-1.165-1.126-1.165zM11.612 6.637 13.16 8.19H5.021V6.637h6.59zm16.354 18.74H5.021v-14.55h22.958v14.55h-.013z"/>
    </svg>
  );
}
